// TabsAndButton.js
import { Tabs, Tab, Button, Box, useTheme } from '@mui/material';
import { useState } from 'react';
import CreateUpdatePost from '../CreateUpdatePost';
import { useAuth } from '../../../hooks/useAuth';

const FeedTopbar = ({
  tabValue,
  handleTabChange,
  handleNavChange,
  scrollBoxRef,
}) => {
  const [showCreatePost, setShowCreatePost] = useState<boolean>(false);
  const theme = useTheme();
  const { authUser, setLoginModalVisible } = useAuth();

  const handleCreate = () => {
    if (authUser) {
      setShowCreatePost(true);
    } else {
      setLoginModalVisible({
        isOpen: true,
        formType: 'signin',
        currentStep: 1,
      });
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        my: 0.5,
        px: { xs: 1, md: 2 },
        [theme.breakpoints.down('md')]: {
          borderBottom: 'solid 1px',
          borderColor: theme.palette.divider,
        },
      }}
    >
      <Tabs
        value={tabValue}
        onChange={handleTabChange}
        indicatorColor='primary'
        textColor='primary'
        variant='standard'
      >
        <Tab
          label='Headlines'
          sx={{
            color: tabValue === 0 ? 'text.primary' : 'text.secondary',
            typography: tabValue === 0 ? 'h7' : 'body1',
            borderBottom: '5px solid',
            borderBottomColor: tabValue === 0 ? 'text.primary' : 'transparent',
            textTransform: 'none',
            px: { xs: 1, md: 'auto' },
          }}
          onClick={() => {
            scrollBoxRef.current?.scrollTo({
              top: 0,
              left: 0,
              behavior: 'smooth',
            });
            handleNavChange({ value: 'headlines' });
          }}
        />
        <Tab
          label='Community'
          sx={{
            color: tabValue === 1 ? 'text.primary' : 'text.secondary',
            typography: tabValue === 1 ? 'h7' : 'body1',
            borderBottom: '5px solid',
            borderBottomColor: tabValue === 1 ? 'text.primary' : 'transparent',
            textTransform: 'none',
            px: { xs: 1, md: 'auto' },
          }}
          onClick={() => {
            scrollBoxRef.current?.scrollTo({
              top: 0,
              left: 0,
              behavior: 'smooth',
            });
            handleNavChange({ value: 'ask' });
          }}
        />
        {!!authUser && (
          <Tab
            label='Following'
            sx={{
              color: tabValue === 2 ? 'text.primary' : 'text.secondary',
              typography: tabValue === 2 ? 'h7' : 'body1',
              borderBottom: '5px solid',
              borderBottomColor:
                tabValue === 2 ? 'text.primary' : 'transparent',
              textTransform: 'none',
              px: { xs: 1, md: 'auto' },
            }}
            onClick={() => {
              scrollBoxRef.current?.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth',
              });
            }}
          />
        )}
      </Tabs>
      <Button
        variant='contained'
        color='primary'
        size='medium'
        sx={{
          marginLeft: { xs: 1, md: 2 },
          flexShrink: 0,
          fontSize: { xs: '14 !important', md: 'auto' },
        }}
        onClick={handleCreate}
      >
        Post
      </Button>

      {showCreatePost && (
        <CreateUpdatePost
          createUpdatePostVisible={showCreatePost}
          setCreateUpdatePostVisible={setShowCreatePost}
        />
      )}
    </Box>
  );
};

export default FeedTopbar;
